/* Copyright (C) Startuplab - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by América Mendoza <america@startuplab.mx>, September 2019
 */

import React from 'react';
import KomunidadApi from '../api/api.js';
import PropTypes from 'prop-types';
import Select from 'react-select';

//Other imports
import { orderBy } from 'lodash';

/** Pick one or multiple programs.
*   Returns an array of ids or the id of the selected program(s).
*   The difference between [ProgramsPicker](/#programspicker) is that this one is used by the view of mentors.
*/

class ProgramsMentorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      programs:[],
      multipleOptions:[],
      multipleProgramSelected:[]
    }
    this.setMultipleOptions     = this.setMultipleOptions.bind(this);
    this.handleMultipleSelect   = this.handleMultipleSelect.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if(state.multipleProgramSelected !== null){
      if ((state.multipleProgramSelected.length === 0) && (props.multipleProgramSelected !== state.multipleProgramSelected)){
        let _selected = [];
        if(state.multipleOptions.length > 0){

          //Filter the multiple option array to set the selected programs
          _selected = state.multipleOptions.filter(function(option){
            return props.multipleProgramSelected.indexOf(option.value) !== -1;
          });

        }
        return {
          multipleProgramSelected: _selected
        };
      }
    }
    // Return null if the state hasn't changed
    return null;
  }

  sortProgramsByDate(programs){
    if(programs.length > 0){
      programs = orderBy(programs, ['created_at'], ['desc']);
      return programs;
    }else{
      return [];
    }
  }

  componentDidMount(){
    KomunidadApi.getMyPrograms().then( (res) => {
      if(res.success){
        let sortedPrograms = this.sortProgramsByDate(res.programs)
        if(!this.props.showInactivePrograms){
          var today = Date.now();
          sortedPrograms = sortedPrograms.filter(function (program) {
            var startDate = new Date(program.start_date);
            var endDate = new Date(program.end_date);
            endDate.setDate(endDate.getDate() + 1);
            return ((today >= startDate.getTime()) && (today <= endDate.getTime()));
          });
        }
        this.setState({
          programs:sortedPrograms,
        });
        if (res.programs.length > 0 && !this.props.showMyMentors) {
          let fisrtProgram = {
            value: sortedPrograms[0]._id,
            label: sortedPrograms[0].name,
          };
          this.handleMultipleSelect(fisrtProgram);
        }
        this.setMultipleOptions(sortedPrograms);
      }
    });
  }

  setMultipleOptions(programs){
    if (this.props.showMyMentors){
      programs.unshift({_id:'mine', name:'Mis expertos'});
    }
    // programs.unshift({_id:'all', name:'Todos los expertos'});

    let options = programs.map(program => ({ value: program._id, label: program.name }));
    this.setState({multipleOptions:options});
  }

  handleMultipleSelect(selectedOption){
    this.setState({multipleProgramSelected:selectedOption});
    let sOption = [selectedOption] || [];
    let programsIds = sOption.length > 0 ? sOption.map( option => option.value ) : [];

    this.props.onSelect(programsIds);
  }

  render(){
    return(
        <Select
          value={this.state.multipleProgramSelected}
          onChange={this.handleMultipleSelect}
          options={this.state.multipleOptions}
          placeholder={''}
        />
    )
  }
}

ProgramsMentorPicker.propTypes = {
  /** Callback on program selected, returns the id or an array of ids. */
  onSelect                : PropTypes.func,
  /** Selected programs. */
  multipleProgramSelected : PropTypes.array,
  /** When is true  display the inactive and active (all) programs.*/
  showInactivePrograms   : PropTypes.bool,
}
ProgramsMentorPicker.defaultProps = {
  onSelect                : (program) => {},
  showMyMentors           : false,
  showInactivePrograms    : true,
  multipleProgramSelected : [],
}

export default ProgramsMentorPicker;
